/* eslint-disable comma-dangle */
import React from 'react'
import { compose } from 'recompose'
import FormLanguage from 'components/forms/FormLanguage'
import withIntl from 'store/intl/withIntl'

const TypeEditor = compose(
  withIntl(),
)(
  ({
    isEditing,
    noLabel,
    value,
    onChange,
  }) => {
    if (!isEditing) {
      return (
        <span>{value.en} / {value.th}</span>
      )
    }
    return (
      <FormLanguage noLabel={noLabel} value={value} onChange={onChange} />
    )
  }
)

TypeEditor.propTypes = {}
TypeEditor.defaultProps = {}

export default TypeEditor



// WEBPACK FOOTER //
// ./src/components/forms/storeLocator/TypeEditor.js